export class DataType {
  public Id: number;
  public Name: string;

  constructor(id, name) {
    this.Id = id;
    this.Name = name;
  }
}
